import Vue from 'vue'
import Alter from './src/main.vue'

Alter.install = (options) => {
  if (document.querySelector('.leon_alter' + (options.typeId ? options.typeId : ''))) {
    return
  }
  const AlterBox = Vue.extend(Alter)
  let instance = new AlterBox({
    ...options
  }).$mount()

  document.body.appendChild(instance.$el)

  Vue.nextTick(() => {
    instance.show = true
    // show 和弹窗组件里的show对应，用于控制显隐
  })
}

export default Alter



// WEBPACK FOOTER //
// ./src/plugin/leonAlter/index.js